import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head, Link } from '@inertiajs/inertia-vue3';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  props: {
    defaultTeamLeaderboard: {
      type: Object,
      "default": {}
    },
    defaultLiveCounterData: {
      type: Object,
      "default": {
        target: 15000,
        achived: 0,
        remaining: 15000
      }
    },
    defaultRecord: {
      type: Number,
      "default": 0
    }
  },
  data: function data() {
    return {
      teamLeaderboard: this.defaultTeamLeaderboard,
      liveCounterData: this.defaultLiveCounterData,
      record: this.defaultRecord
    };
  },
  mounted: function mounted() {
    this.refreshCounter();
  },
  methods: {
    refreshCounter: function refreshCounter() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.post('/get_team_leaderboard');
              case 2:
                res = _context.sent;
                if (res.data.status == 'success') {
                  _this.teamLeaderboard = res.data.teamLeaderboard;
                  _this.liveCounterData = res.data.liveCounterData;
                  _this.record = res.data.record;
                }
                setTimeout(function () {
                  _this.refreshCounter();
                }, 60000);
                return _context.abrupt("return", true);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};